import React, { lazy, Suspense } from "react";
import { useParams } from "react-router-dom";

const RemoteWithdrawal = lazy(() => import("@/changeservice/components/Withdrawal/Withdrawal"));

const Withdrawal = () => {
  const { id, category } = useParams();

  return (
    <Suspense fallback={<></>}>
      <RemoteWithdrawal category={category ?? ""} id={id ?? ""} />
    </Suspense>
  );
};

export default Withdrawal;
